var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.66667C12 9.92 11.86 10.14 11.6467 10.2533L6.38 13.2133C6.27333 13.2933 6.14 13.3333 6 13.3333C5.86 13.3333 5.72667 13.2933 5.62 13.2133L0.353333 10.2533C0.14 10.14 0 9.92 0 9.66667V3.66667C0 3.41333 0.14 3.19333 0.353333 3.08L5.62 0.12C5.72667 0.04 5.86 0 6 0C6.14 0 6.27333 0.04 6.38 0.12L11.6467 3.08C11.86 3.19333 12 3.41333 12 3.66667V9.66667ZM6 1.43333L2.02667 3.66667L6 5.9L9.97333 3.66667L6 1.43333ZM1.33333 9.27333L5.33333 11.5267V7.05333L1.33333 4.80667V9.27333ZM10.6667 9.27333V4.80667L6.66667 7.05333V11.5267L10.6667 9.27333Z",
    fill: "#0065AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.5f2e6b040d90c5960591606af44c2a0f.svg";
export { ForwardRef as ReactComponent };